/**
 * Which design an agent card renders: the phone design inside a phone transcript (AgentSurface provides
 * `chatBubbles`), and also on a phone outside any transcript (the voice call screen shows the same cards); the
 * desktop design everywhere else.
 *
 * `inTranscript` is false outside a conversation: there are no sheets above the host (the call screen sits
 * over every sheet layer) and no composer to focus, so cards keep everything in place.
 */
import { computed, inject, type ComputedRef, type Ref } from 'vue'
import useChatChrome from '@/composables/useChatChrome'

export function useCardMode(): { phone: ComputedRef<boolean>; inTranscript: boolean } {
    const injected = inject<Ref<boolean> | null>('chatBubbles', null)
    if (injected) return { phone: computed(() => injected.value), inTranscript: true }
    const { isPhone } = useChatChrome()
    return { phone: computed(() => isPhone.value), inTranscript: false }
}
